import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PopupWrapper from '../../../../components/popup/PopupWrapper';
import { PDFViewer } from '@react-pdf/renderer';
import DocumentFormPdfDocument from '../report/components/DocumentFormPdfDocument';

/**
 * PDF Viewer 팝업 컴포넌트
 * - 공통 팝업(PopupWrapper/Portal)을 사용
 * - config.getImages()로 미리보기 화면 캡처 이미지를 받아 PDFViewer로 렌더링
 */
const PdfViewerPopup = ({ config, onClose }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError('');
      setImages([]);
      try {
        const fn = config?.getImages;
        if (typeof fn !== 'function') {
          throw new Error('getImages is not a function');
        }
        const pages = await fn();
        if (cancelled) return;
        const imgs = Array.isArray(pages) ? pages.filter(Boolean) : [];
        setImages(imgs);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        if (cancelled) return;
        setError(t('popup.pdfViewer.generateFailed'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [config, t]);

  const pdfDoc = useMemo(() => {
    return <DocumentFormPdfDocument images={images} />;
  }, [images]);

  return (
    <PopupWrapper
      config={config}
      onClose={onClose}
      displayType={config?.displayType || 'modal'}
      className="popup-pdf-viewer"
    >
      <div className="main-popup-body" style={{ width: '100%' }}>
        {loading ? (
          <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
            <div style={{ color: '#495057', fontWeight: 600 }}>{t('popup.pdfViewer.generating')}</div>
          </div>
        ) : error ? (
          <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
            <div style={{ color: '#dc3545', fontWeight: 600 }}>{error}</div>
          </div>
        ) : images.length === 0 ? (
          <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
            <div style={{ color: '#495057', fontWeight: 600 }}>{t('popup.pdfViewer.empty')}</div>
          </div>
        ) : (
          <div style={{ width: '100%', height: '100vh' }}>
            <PDFViewer className="dfb-pdfviewer">
              {pdfDoc}
            </PDFViewer>
          </div>
        )}
      </div>

      <div className="main-popup-footer d-flex justify-content-center">
        {/* <button
          type="button"
          className={`btn main-popup-right-btn ${getButtonClass('btn-outline-secondary')}`}
          onClick={() => onClose(false)}
          style={{ width: 180 }}
        >
          닫기
        </button> */}
      </div>
    </PopupWrapper>
  );
};

export default PdfViewerPopup;

